



































import Vue from 'vue'
import { Component, Prop } from 'vue-property-decorator'

import MultiMessageEditorWithMediaInput
  from '../../../../../../../../Pi/fields/NewMultiMessageEditorWithMediaInput/MultiMessageEditorWithMediaInput.vue'
import { FieldData } from '../../../../../../../../Pi/types'
import CustomEditor from '../../../../../Editor/CustomEditor'
import { EditLastMessageNode } from '../../logic/EditLastMessageNode'

@Component({
  components: {
    MultiMessageEditorWithMediaInput,
  },
})
export default class EditLastMessageSidebar extends Vue {
  @Prop() node!: EditLastMessageNode

  @Prop() editor!: CustomEditor

  get placeholders() {
    if (typeof this.node.nodeProps.placeholders === 'function') {
      return this.node.nodeProps.placeholders()
    } else {
      return []
    }
  }

  setMessage(arg: FieldData): FieldData {
    arg.setter = (val) => this.node.changeMessages(val, this.editor)

    return arg
  }
}
